import Api from '@/services/Api'

const resource = 'generaciones'

export default {
  getGeneraciones() {
    return Api().get(`${resource}`)
  },
  getGeneracionesActivas() {
    return Api().get(`${resource}/actives`)
  },
  addGeneration(data) {
    return Api().post(`${resource}/`, data)
  },
  getGenByConv(params) {
    return Api().get(`${resource}`, { params })
  },
  exportData(filters) {
    // return Api().get('export-data-generaciones', {
    return Api().get('export-data-v2', {
      params: { ...filters },
      responseType: 'arraybuffer',
    })
  },
}
